<template>
    <section class="section section-lg bg-default">
        <div class="container container-wide">
            <b-alert :show="!this.isEmpty(transitionType)" variant="info" dismissible fade>
                <h5 class="notice-title">{{ this.transitionText('NOTICE_TITLE') }}</h5>
                <div class="notice-description">
                    ご利用の再開・再購入時には、カード情報をあらためてご入力ください。<br/> 
                    決済は、定期購入分は月初1日に、再購入分は手続き当日に行われますが、<br/> 
                    アカウントページに記載されるまで数日を要する場合がございます。 <br/>
                    決済代行会社の切り替えに関する詳細は<a target="_blank" href="https://eowp.blogspot.com/2022/06/blog-post.html">こちら</a>でご確認ください。
                </div>
            </b-alert>
            <b-alert :show="!this.isEmpty(form.errors.card_error)" variant="danger" dismissible fade v-html="form.errors.card_error"></b-alert>
            <div class="row row-fix row-50 justify-content-lg-center">
                <div v-show="this.paymentPageUnderMaintenance">
                        <div class="maintenance-instruction">
                            <h2>メンテナンスのお知らせ</h2>
                            <ul class="maintenance-description">
                                <li>大変申し訳ございません。</li>
                                <li>メンテナンス中のため、お支払いを完了することができません。</li>
                                <li>メンテナンス終了後再度お試しください。</li>
                            </ul>
                        </div>
                        <div class="maintainance-buttons">
                            <div class="button buttons button-xs button-default-outline change-credit-card mobile-button2" @click="redirect('maintennance_page_account_redirect')">アカウントページに戻る</div>
                        </div>
                </div>
                <div class="row row-fix row-50 justify-content-lg-center" v-show="!this.paymentPageUnderMaintenance">
                    <div class="text-header">
                        <span>{{this.transitionText('TITLE')}}</span>
                    </div>
                    <div>
                        <div class="intruction-text">{{this.transitionText('DETAILS')}}</div>
                        <div class="instruction-note">
                            ※CVC：Card Verification Code（カード認証コード）とは？<br />
                            カードの裏面などに記載されている、数字３～4桁の認証用コードです。<br />
                            セキュリティコード、CVV（card verification value）などの呼称が用いられる場合もあります。
                        </div>
                    </div>
                    <div v-if="!form.pg_intent_loaded" class="page-loading-indicator">
                        <img src="/images/eowp/animation/loading-spinner.jpg" />
                    </div>
                    <div class="form-container">
                        <form id="payment-form" :class="form.pg_intent_loaded ? '' : 'hidden'">
                            <div class="form-wrap form-wrap-validation">
                                <input class="form-input" id="subscriber-full-name" v-model="form.cardHolderFullName" type="text" name="street-address" :placeholder="form.cardHolderPlaceholder">
                            </div>
                            <div id="card-element"><!--Stripe.js injects the Card Element--></div>
                            <button id="submit" :disabled="form.button_disabled || form.loading || !form.cardHolderFullName">
                                <div class="spinner" :class="form.loading ? '' : 'hidden'" id="spinner"></div>
                                <span id="button-text" :class="form.loading ? 'hidden' : ''">{{this.transitionText('BUTTON')}}</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notice-title{
    color: inherit;
    font-weight: 600;
    margin-bottom: 5px;
}
.notice-description {
    font-size: 14px;
}
@media (max-width: 550px) {
    .notice-description br {
        display: none;
    }
}
.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}
.maintenance-description{
    max-width: 500px;
    position: relative;
    display: inline-block;
    text-align: left;
    margin-top: 40px;
    margin-bottom: 20px;
}
.maintenance-description li{
    padding-top: 15px;
}
.maintenance-instruction{
    position: relative;
    display: block;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 30px;
}
.maintenance-instruction span{
    padding-top: 35px!important;
    padding-bottom: 40px!important;
    position: relative;
    display: block;
}
.maintainance-buttons div.button{
    max-width: 320px;
}
section {
    padding-top: 25px !important;
    text-align: center;
}
.form-container {
    width: 100%;
    position: relative;
    display: block;
    text-align: -webkit-center;
    text-align: -moz-center !important;
}
.text-header {
    width: 100%;
    position: relative;
    display: block;
    text-align: center;
    font-size: 25px;
    margin-bottom: 10px;
    padding-top: 20px !important;
}
.text-instruction {
    width: 100%;
    position: relative;
    display: block;
    text-align: center;
    font-size: 14px;
}
.instruction-note {
    margin-top: 20px;
    font-size: 14px;
    max-width: 780px;
    position: relative;
    display: inline-flex;
}
@media (max-width: 496px) {
    .instruction-note br {
        display: none;
    }
}
.page-loading-indicator {
    width: 100%;
    position: relative!important;
    display: block!important;
    text-align: center;
    position: relative;
    display: inline-flex;
}
.page-loading-indicator > img {
    width: 50px;
}
form {
  width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
  margin-right: 3px;
}
input {
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  font-size: 16px;
  width: 100%;
  background: white;
}
.hidden {
  display: none;
}
#card-element {
  border-radius: 4px 4px 0 0 ;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}
#payment-request-button {
  margin-bottom: 32px;
}
/* Buttons and links */
button {
  background: #5469d4;
  color: #ffffff;
  font-family: Arial, sans-serif;
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}
.override-affiliate{
    margin-bottom: 5px !important;
}
.override-affiliate-button{
    background: #ff0000;
    padding: 2px 2px !important;
    width: 220px;
    border-radius: 4px 4px 4px 4px;
    display:inline-block;
}
/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}
@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
  }
}
.row {
    display: block;
    margin-left: auto;
    margin-right: auto
}
article{
    padding-top: 150px;
    padding-bottom: 150px;
}
.maintainance-buttons{
    padding-top: 40px;
    margin: 0 auto;
    display: inline-grid;
}
@media (max-width: 536px) {
    form {
        min-width: 460px!important;
    }
}
@media (max-width: 483px) {
    form {
        min-width: 380px!important;
    }
}
@media (max-width: 404px) {
    form {
        min-width: 334px!important;
    }
}
@media (min-width: 240px) and (max-width: 360px) {
    form {
        min-width: 280px!important;
    }
}
@media (min-width: 150px) and (max-width: 336px) {
    form {
        min-width: 220px!important;
    }
}
</style>

<script>
import { BAlert } from "bootstrap-vue";
import Utils from '../../../js/helpers/Utils';
import { mapActions, mapGetters } from "vuex";
import BaseModel from '../../../js/models/BaseModel';
import TransitionModel from '../../../js/models/secure/TransitionModel';
import DialogMixin from '../../../js/helpers/mixins/DialogMixin';

export default {
    data(){
        return {
            paymentPageUnderMaintenance: '',
            affiliateSubmission: '',
            overrideAffiliateDetails: false,
            showAffiliateCookieDialog: false,
            form: {
                button_disabled: true,
                pg_intent_loaded: false,
                errors: {
                    card_error: '',
                    stripe_errors: {
                        incomplete: '処理を完了することができませんでした。<br />お手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // the process was not able to complete. please check with your card company or use another credit card.
                        default: '処理を完了することができませんでした。<br />時間を置いてお試しいただきますようお願いいたします。<br />解決しない場合はお手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">英辞郎 on the WEBお問い合わせフォーム</a>からお問い合わせください。' // the process was not able to complete. please try again after sometimes. if this is not solving the problem, please contact us through the inquiry form
                    },
                    payment_errors: {
                        ERR19: '購入されたサブスクリプションを当社のシステムに同期させようとしているときに、予期せぬエラーが発生しました。新しいものを購入しようとせず、以下の情報を添えてすぐに管理者にこの問題を報告してください。', //We have encountered an unexpected error while we are trying to sync the purchased subscription to our system. Please do not attempt to purchase new one, and report this issue to our administrator immediately with the following information.
                        card_declined: '処理を完了することができませんでした。<br />お手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // the process was not able to complete. please check with your card company or use another credit card.
                        default: '処理を完了することができませんでした。<br />時間を置いてお試しいただきますようお願いいたします。<br />解決しない場合はお手数ですが、<a target="_blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new">英辞郎 on the WEBお問い合わせフォーム</a>からお問い合わせください。' // the process was not able to complete. please try again after sometimes. if this is not solving the problem, please contact us through the inquiry form
                    }
                },
                loading: false,
                cardHolderFullName: '',
                transitionTexts: {
                    CCC: {
                        TITLE: 'ご利用カード情報の更新', //Update Credit Card Information
                        DETAILS: 'クレジットカードに記載された「カード名義人（氏名）」「カード番号」「月／年」「CVC（セキュリティコード）」を入力してください。', //Please enter the "Card Holder (Name)", "Card Number", "Month/Year" and "CVC (Security Code)" on your credit card.
                        NOTICE_TITLE: '決済代行会社の切り替えに伴う変更のお知らせ', // Notification of changes due to switching of payment agency
                        NOTICE_DESC: '決済代行会社の切り替えに伴い、以下の点が変わります。詳細は<a target="_blank" href="https://eowp.blogspot.com/2022/06/blog-post.html">こちら</a>でご確認ください。<br />1.次回以降のご利用料金は、月初1日にご請求<br />2.現在ご継続中の定期購入（サブスクリプション）の注文番号が更新', // two things will be changes. 1. billing cycle is going to be the first day of the month 2. the current subscription order number will be updated
                        BUTTON: '更新' //update now
                    },
                    RESUME: {
                        TITLE: 'サブスクリプションお申し込み（クレジットカード決済）', //Subscription application (Credit Card Payment)
                        DETAILS: 'クレジットカードに記載された「カード名義人（氏名）」「カード番号」「月／年」「CVC（セキュリティコード）」を入力してください。', //Please enter the "Card Holder (Name)", "Card Number", "Month/Year" and "CVC (Security Code)" on your credit card.
                        NOTICE_TITLE: '決済代行会社の切り替えに伴う変更のお知らせ', // Notification of changes due to switching of payment agency
                        NOTICE_DESC: '決済代行会社の切り替えに伴い、以下の点が変わります。詳細は<a target="_blank" href="https://eowp.blogspot.com/2022/06/blog-post.html">こちら</a>こちらでご確認ください。<br />1.次回以降のご利用料金は、月初1日にご請求', // things will be changes. 1. billing cycle is going to be the first day of the month
                        BUTTON: '再開' //resume now
                    },
                    UPGRADE: {
                        TITLE: 'サブスクリプションお申し込み（クレジットカード決済）', //Subscription application (Credit Card Payment)
                        DETAILS: 'クレジットカードに記載された「カード名義人（氏名）」「カード番号」「月／年」「CVC（セキュリティコード）」を入力してください。', //Please enter the "Card Holder (Name)", "Card Number", "Month/Year" and "CVC (Security Code)" on your credit card.
                        NOTICE_TITLE: '決済代行会社の切り替えに伴う変更のお知らせ', // Notification of changes due to switching of payment agency
                        NOTICE_DESC: '決済代行会社の切り替えに伴い、以下の点が変わります。詳細は<a target="_blank" href="https://eowp.blogspot.com/2022/06/blog-post.html">こちら</a>こちらでご確認ください。<br />1.次回以降のご利用料金は、月初1日にご請求', // things will be changes. 1. billing cycle is going to be the first day of the month
                        BUTTON: '更新' //update now
                    }
                },
                cardHolderPlaceholder: 'カード名義人（氏名）', //Cardholder's Full Name
            },
            eowp: {
                item: {
                    id: '',
                    name: '',
                    price: '',
                    userId: '',
                    userEmail: '',
                    userName: ''
                },
                stripeControlCode: '',
                stripeControlName: 'stripe_payment_gateway',
                affiliateSubmissionControlCode: '',
                affiliateSubmissionControlName: 'affiliate_submission',
            },
            affiliate: {
                cookieName: 'AFFILIATE_CNOM',
                cookieCodeName: 'AFFILIATE_CODE',
                validValues: ['a8net', 'deeptrack'], // If this gets changed, update executeAffiliate() method logic
                value: '',
                code: '',
                orderId: ''
            }
        };
    },
    async created(){
        // Check required parameters
        if(!this.validTransitionParams()){
            this.$router.push("/account");
            return;
        }

        // Determine if this user has pending subscription for sync - hard redirect to account page instead
        await this.pendingSubscriptionSync({userId: this.sessionDetails.userId, sessionId: this.sessionDetails.sessionId}).then(res => {
            if(res.SYNC && res.SYNC > 0){ this.$router.push("/account"); return; }
        });

        console.log(this.transitionText('TITLE'), "this.transitionText('TITLE')");
        console.log(this.transitionText('DETAILS'), "this.transitionText('DETAILS')");
        console.log(this.transitionText('NOTES'), "this.transitionText('NOTES')");
        console.log(this.transitionText('BUTTON'), "this.transitionText('BUTTON')");

        let userData = {
            userId: this.sessionDetails.userId,
            sessionId: this.sessionDetails.sessionId,
            action: this.eowp.stripeControlName
        };
        await this.verifyAccess(userData).then(res => {
            this.paymentPageUnderMaintenance = res.status_code != "ERR0";
        });

        await this.fetchUserDetails({sessionId: this.userDetails.sessionId, email: this.userEmail}).then(res => {
            //Make sure it's legit active user session
            if(res.status != BaseModel.STATUS_SUCCESS){
                this.$router.push("/signout");
                return;
            }
            this.eowp.item.userId = res.records.id;
            this.eowp.item.userEmail = res.records.email;
            this.eowp.item.userName = res.records.name;
        });

        // Check legit user
        if(this.eowp.item.userId != this.transitionUserId){
            this.$router.push("/account");
            return;
        }

        await this.retrieveProduct(this.transitionCsMatNo).then(res => {
            console.log(res, "Product");
            if(!res.records || Utils.isEmpty(res.records.csMatNo) || Utils.isEmpty(res.records.productName) || Utils.isEmpty(res.records.productPriceWithTax)){
                this.$router.push("/basket");
                return;
            } else {
                this.eowp.item.id = res.records.csMatNo;
                this.eowp.item.name = res.records.productName;
                this.eowp.item.price = res.records.productPriceWithTax;
                this.eowp.item.basePrice = res.records.productPrice;
            }
        });

        this.getPGClientKey().then(() => {
            if(typeof window.Stripe !== 'function'){
                let vm = this;
                window.jQuery("script#spScript1").ready(() => {
                    let intervalid = setInterval(() => {
                        if(typeof window.Stripe === 'function'){
                            clearInterval(intervalid);
                            vm.form.pg_intent_loaded = true;
                            vm.initStripe();
                        }
                    }, 5);
                });
            } else {
                this.form.pg_intent_loaded = true;
                this.initStripe();
            }
        });
    },
    mounted(){
        if(typeof window.Stripe !== 'function'){
            Utils.loadScript("https://js.stripe.com/v3/", "spScript1");
        }
    },
    computed: {
        ...mapGetters({
            clientKey: 'pg/client_key',
            intentKey: 'pg/intent_key',
            itemCharge: 'pg/item_charge',
            freeMonth: 'pg/free_month',
            updateCC: 'pg/update_cc',
            readAgreement: 'pg/read_agreement',
            chosenItem: 'ncs/chosen_item',
            product: 'ncs/product',
            userDetails: 'user/session_details',
            userEmail: 'user/user',
            productTypes: 'ncs/product_types',
            sessionDetails: 'user/session_details',
            transitionUserId: 'transition/transition_userid',
            transitionCsMatNo: 'transition/transition_csmatno',
            transitionCsOrderNo: 'transition/transition_csorderno',
            subscriber: 'transition/subscriber_type',
            transitionType: 'transition/transition_type'
        })
    },
    methods: {
        ...mapActions({
            getPGClientKey: 'pg/getPGClientKey',
            createSubscription: 'pg/createSubscription',
            setPaymentSuccessFlag: 'pg/setSuccessFlag',
            updatePaymentMethod: 'pg/updatePaymentMethod',
            pendingSubscriptionSync: 'pg/pendingSubscriptionSync',
            retrieveProduct: 'ncs/retrieveProduct',
            fetchUserDetails: 'user/fetchUserDetails',
            getNewOrderId: 'ncs/getNewOrderId',
            setPathIntention: 'user/setPathIntention',
            trackClickEvent: 'ga/trackClickEvent',
            retrieveControllerDetails: 'control/retrieveControllerDetails',
            verifyAccess: 'user/verifyAccess',
            subscribe: 'transition/subscribe',
            logActivity: 'log/logActivity',
        }),
        validTransitionParams(){
            let passed = true;
            passed = !passed ? passed : !(Utils.isEmpty(this.subscriber) || this.subscriber != TransitionModel.OLD_SUBSCRIBER);
            passed = !passed ? passed : !Utils.isEmpty(this.transitionUserId);
            passed = !passed ? passed : !Utils.isEmpty(this.transitionCsMatNo);
            passed = !passed ? passed : !Utils.isEmpty(this.transitionCsOrderNo);
            passed = !passed ? passed : !Utils.isEmpty(this.transitionType);
            passed = !passed ? passed : this.transitionType == TransitionModel.TRANSITION_TYPE_CCC ||
                                        this.transitionType == TransitionModel.TRANSITION_TYPE_RESUME ||
                                        this.transitionType == TransitionModel.TRANSITION_TYPE_UPGRADE;
            return passed;
        },
        transitionText(node){
            let detailType = this.form.transitionTexts[this.transitionType];
            return detailType[node];
        },
        initStripe(){
            let stripe = window.Stripe(this.clientKey);
            let vm = this;

            let elements = stripe.elements();
            let style = {
                base: {
                    color: "#32325d",
                    fontFamily: 'Arial, sans-serif',
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#32325d"
                    }
                },
                invalid: {
                    fontFamily: 'Arial, sans-serif',
                    color: "#fa755a",
                    iconColor: "#fa755a"
                }
            };

            let card = elements.create("card", { hidePostalCode: true, style: style });
            // Stripe injects an iframe into the DOM
            card.mount("#card-element");
            card.on("change", function (event) {
                // Disable the Pay button if there are no card details in the Element
                console.log(event, "card is changing...");
                if (event.error) {
                    event.error.message = vm.form.errors.stripe_errors[event.error.code] ? vm.form.errors.stripe_errors[event.error.code] : event.error.message;
                }
                vm.errorMessage(event);
            });

            let form = document.getElementById("payment-form");
            form.addEventListener("submit", function(event) {
                vm.loadingIndicator(true);
                event.preventDefault();
                vm.form.errors.card_error = '';
                // Complete payment when the submit button is clicked
                vm.checkActiveSession().then(isActive => {
                    if(!isActive){
                        vm.loadingIndicator(false);
                        return;
                    }
                    payWithCard(stripe, card);
                });
            });
            
            // Calls stripe.confirmCardPayment
            // If the card requires authentication Stripe shows a pop-up modal to
            // prompt the user to enter authentication details without leaving your page.
            let payWithCard = function(stripe, card) {
                vm.loadingIndicator(true);
                stripe.createPaymentMethod({
                    type: 'card',
                    card: card,
                    billing_details: {
                        name: vm.form.cardHolderFullName,
                        email: vm.userEmail,
                    }
                }).then((result) => {
                    if (result.error) {
                        let stripeErrorMessage = result.error.message ? result.error.message : ''; // record error message from stripe
                        result.error.message = vm.form.errors.stripe_errors[result.error.code] ? vm.form.errors.stripe_errors[result.error.code] : vm.form.errors.stripe_errors['default'];
                        vm.errorMessage(result);

                        // push to backend activity logs 
                        let errorLogMessage = "FRONTEND ERROR: (Transition Page > " + vm.transitionType + "): ERROR-CREATE-PAYMENT-METHOD, userId: " + vm.userDetails.userId;
                        if (vm.eowp.item.id) errorLogMessage += ", csMatNo: " + vm.eowp.item.id;
                        if (!Utils.isEmpty(stripeErrorMessage)) errorLogMessage += ", actualErrorMessage (Stripe): " + stripeErrorMessage;
                        if (result.error.code) errorLogMessage += " (error_code: " + result.error.code + ")";
                        errorLogMessage += ", frontendErrorMessage: " + result.error.message;
                        vm.logActivity({type: "error", message: errorLogMessage});
                        vm.loadingIndicator(false);

                    } else {
                        vm.subscribe({
                            userId: vm.userDetails.userId,
                            sessionId: vm.userDetails.sessionId,
                            csMatNo: vm.eowp.item.id,
                            csOrderNo: vm.transitionCsOrderNo,
                            paymentMethodId: result.paymentMethod.id,
                            subscriber: { name: vm.form.cardHolderFullName },
                            transitionType: vm.transitionType
                        }).then(sub => {
                            // Bypass ERR20 & ERR21 as these are initially succeeded, and reserved for sync, will be caught on account page or in daily/manual sync
                            if(sub.status != "SUCCESS" || Utils.notIn(sub.status_code, "ERR0,ERR20,ERR21")){
                                let errorMessage = vm.form.errors.payment_errors[sub.status_code] ? vm.form.errors.payment_errors[sub.status_code] : vm.form.errors.payment_errors['default'];
                                let errorParams = { complete: true, error: {message: errorMessage, code: sub.status_code} };
                                if(sub.status_code == "ERR7"){
                                    window.location.reload();
                                }else{
                                    console.log("flag error...");
                                    vm.errorMessage(errorParams);
                                }

                                // push to backend activity logs
                                let errorLogMessage = "FRONTEND ERROR: (Transition Page > " + vm.transitionType + "): ERROR-TRANSITION-SUBSCRIBE, userId: " + vm.userDetails.userId;
                                if (vm.eowp.item.id) errorLogMessage += ", csMatNo: " + vm.eowp.item.id;
                                if (vm.transitionCsOrderNo) errorLogMessage += ", csOrderNo: " + vm.transitionCsOrderNo; 
                                if (!Utils.isEmpty(sub.description)) errorLogMessage += ", actualErrorMessage: " + sub.description;
                                if (sub.status_code) errorLogMessage += "(error_code: " + sub.status_code + ")"
                                errorLogMessage += ", frontendErrorMessage: " + errorMessage;
                                vm.logActivity({type: "error", message: errorLogMessage});
                                vm.loadingIndicator(false);

                            } else {
                                vm.$router.push("/account");
                            }
                        });
                    }
                }).catch(error => {
                    console.log(error, "EXCEPTION");
                    vm.errorMessage(error);
                    vm.loadingIndicator(false);

                    // push to backend activity logs
                    let errorLogMessage = "FRONTEND ERROR: (Transition Page > " + vm.transitionType + "): UNEXPECTED-EXCEPTION, userId: " + vm.userDetails.userId;
                    if (vm.eowp.item.id) errorLogMessage += ", csMatNo: " + vm.eowp.item.id;
                    if (vm.transitionCsOrderNo) errorLogMessage += ", csOrderNo: " + vm.transitionCsOrderNo;
                    errorLogMessage += ", actualError: " + error; 
                    vm.logActivity({type: "error", message: errorLogMessage});
                });
            };
        },
        errorMessage(result){
            this.form.errors.card_error = '';
            this.form.button_disabled = result.empty || !result.complete;
            if (result.error) {
                this.form.errors.card_error = result.error.message ? result.error.message : this.form.errors.payment_errors['default'];
                if (result.error.code) {
                    this.form.errors.card_error += ' (error_code: ' + result.error.code + ')';
                }
            }
        },
        loadingIndicator(flag){
            this.form.loading = flag;
        },
        isEmpty(object){
            return Utils.isEmpty(object);
        },
        redirect(eventName){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title});
            this.$router.push("/account");
        },
    },
    components: {
        BAlert
    },
    mixins: [
        DialogMixin
    ]
};
</script>
